import { lightTheme } from "@/customTheme";

const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 1V3.13086H4.89844C4.33027 3.13088 3.89555 3.28125 3.59473 3.58203C3.29387 3.88289 3.14355 4.33048 3.14355 4.92383V19.0889C3.14355 19.6739 3.29387 20.1171 3.59473 20.418C3.89555 20.7187 4.33027 20.8691 4.89844 20.8691H19.1016C19.6614 20.8691 20.0961 20.7187 20.4053 20.418C20.7145 20.1171 20.8691 19.6739 20.8691 19.0889V9H23V19.2393C23 20.4842 22.6784 21.4201 22.0352 22.0469C21.4001 22.682 20.4512 23 19.1895 23H4.81055C3.55712 23 2.60829 22.682 1.96484 22.0469C1.32162 21.4201 1 20.4842 1 19.2393V4.77344C1 3.5285 1.32162 2.58826 1.96484 1.95312C2.60829 1.31803 3.55712 1.00005 4.81055 1H15Z"
      fill={props.fill ? props.fill : lightTheme.colors.blackGray}
    />
    <path
      d="M2.25 17.3846L8.09615 12L13.5 17.5L16.8654 14.6923L21.25 19"
      stroke={props.fill ? props.fill : lightTheme.colors.blackGray}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 8.5C8.7165 8.5 9.5 7.7165 9.5 6.75C9.5 5.7835 8.7165 5 7.75 5C6.7835 5 6 5.7835 6 6.75C6 7.7165 6.7835 8.5 7.75 8.5Z"
      fill={props.fill ? props.fill : lightTheme.colors.blackGray}
    />
    <path
      d="M20.0054 -1.30384e-06C19.7679 -1.28307e-06 19.6347 0.125954 19.6059 0.377866C19.5268 1.05443 19.4404 1.58344 19.3468 1.96491C19.2605 2.35358 19.1165 2.64507 18.915 2.83941C18.7206 3.03374 18.4256 3.18129 18.0297 3.28205C17.6338 3.38282 17.094 3.48718 16.4103 3.59514C16.1368 3.63833 16 3.77508 16 4.0054C16 4.22852 16.1188 4.36167 16.3563 4.40486C17.0544 4.53441 17.605 4.64957 18.0081 4.75034C18.4112 4.8583 18.7134 5.00585 18.915 5.19298C19.1165 5.38731 19.2605 5.67161 19.3468 6.04588C19.4404 6.42015 19.5268 6.94197 19.6059 7.61134C19.6347 7.87044 19.7679 8 20.0054 8C20.2501 8 20.3869 7.87404 20.4157 7.62213C20.502 6.93837 20.592 6.40216 20.6856 6.01349C20.7791 5.62483 20.9231 5.32973 21.1174 5.1282C21.3117 4.93387 21.6068 4.78632 22.0027 4.68556C22.4058 4.59199 22.96 4.49842 23.6653 4.40486C23.7661 4.39046 23.8489 4.34728 23.9136 4.2753C23.9856 4.20333 24.0216 4.11336 24.0216 4.0054C24.0216 3.77508 23.9028 3.63833 23.6653 3.59514C22.96 3.46559 22.4094 3.34683 22.0135 3.23887C21.6176 3.1309 21.3189 2.97976 21.1174 2.78542C20.9231 2.59829 20.7791 2.31399 20.6856 1.93252C20.592 1.55825 20.502 1.03284 20.4157 0.356274C20.4013 0.255509 20.3545 0.169139 20.2753 0.0971643C20.2033 0.0323874 20.1134 -1.31328e-06 20.0054 -1.30384e-06Z"
      fill={props.fill ? props.fill : lightTheme.colors.blackGray}
    />
  </svg>
);

export default SVGComponent;
